import { useWorkflowGraphState } from "#src/batteries-included-components/Graph/WorkflowGraph/WorkflowGraphCanvas/WorkflowGraphStore";
import {
  CheckboxInput,
  DropdownInput,
  Form,
  useForm,
  VariableTextInput,
} from "@validereinc/common-components";
import { Workflows } from "@validereinc/domain-controllers";
import { toTitleCaseString } from "@validereinc/utilities";
import React, { useEffect } from "react";
import { WorkflowTaskPriorityIcon } from "../../../../Panels/TablePanels/WorkflowsTablePanel/WorkflowsTablePanel.helpers";
import {
  useWorkflowConfigurationFormStore,
  WorkflowConfigurationBaseInformationFormValues,
} from "../WorkflowConfigurationFormStore";

const { WorkflowTaskPriorityIdToLabelMap } = Workflows.view;

const WorkflowTaskPriorityDropdownOptions = [
  {
    value: "2",
    label: toTitleCaseString(WorkflowTaskPriorityIdToLabelMap[2], {
      intent: "ui",
    }),
    slotLeft: <WorkflowTaskPriorityIcon priorityId={2} />,
  },
  {
    value: "1",
    label: toTitleCaseString(WorkflowTaskPriorityIdToLabelMap[1], {
      intent: "ui",
    }),
    slotLeft: <WorkflowTaskPriorityIcon priorityId={1} />,
  },
  {
    value: "0",
    label: toTitleCaseString(WorkflowTaskPriorityIdToLabelMap[0], {
      intent: "ui",
    }),
    slotLeft: (
      <WorkflowTaskPriorityIcon
        priorityId={0}
        shouldRenderNoneLabel
      />
    ),
  },
];

const WorkflowConfigurationBaseInformation = ({
  stepId,
  isStepSystemAction,
}: {
  stepId: string;
  isStepSystemAction: boolean;
}) => {
  const { setBaseInformation, setBaseInformationIsValid, getBaseInformation } =
    useWorkflowConfigurationFormStore();

  const { getAvailableStepVariables } = useWorkflowGraphState();

  const storeValues = getBaseInformation(isStepSystemAction);

  const form = useForm<WorkflowConfigurationBaseInformationFormValues>({
    values: storeValues,
  });

  const availableVariables = getAvailableStepVariables(stepId);

  useEffect(() => {
    setBaseInformationIsValid(form.formState.isValid);
  }, [form.formState.isValid, setBaseInformationIsValid]);

  const handleValueChange = (
    key: "name" | "description" | "priority_id" | "is_dismissible",
    value: unknown
  ) => {
    if (storeValues) {
      setBaseInformation({
        ...storeValues,
        [key]: value,
      });
    }
  };

  return (
    <Form
      {...form}
      style={{ maxWidth: 432 }}
    >
      <VariableTextInput
        name="name"
        label="Task Name"
        isRequired
        suggestions={availableVariables}
        type="text"
        onChange={(newValue: string) => {
          handleValueChange("name", newValue);
        }}
      />
      <VariableTextInput
        name="description"
        label="Task Description"
        isRequired={!isStepSystemAction}
        suggestions={availableVariables}
        type="textarea"
        onChange={(newValue: string) => {
          handleValueChange("description", newValue);
        }}
      />
      {!isStepSystemAction && (
        <>
          <DropdownInput
            label="Priority"
            name="priority_id"
            labelKey="label"
            valueKey="value"
            isRequired
            options={WorkflowTaskPriorityDropdownOptions}
            noSearchDebounce
            onChange={(newValue: string) => {
              handleValueChange("priority_id", newValue);
            }}
          />
          <CheckboxInput
            name="is_dismissible"
            label="Task is dismissible"
            isLabelShown={false}
            style={{ marginBottom: 0 }}
            onChange={(newValue: boolean) => {
              handleValueChange("is_dismissible", newValue);
            }}
          />
        </>
      )}
    </Form>
  );
};

export default WorkflowConfigurationBaseInformation;
